import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OutboundSORBAC = {
  pageID: 'c852b60907624f74f2ec14705f765d7d',
  elementID: {
    LinkDetail: '0bc0079278c414cc4cf14bbcc39ae9b6',
    BtnCreateSupplyOrderGrouped: '9bcdb05d81e6ccf64a2c4f628f184299',
    BtnCetakSuratJalan: '83f2e6d24d4cb5b697d7277d58346898',
    BtnDelivery: '2b9765ca7bf803206ee8d8b3cd818177',
    MenuItemUpdatePicker: '089c3dc318a1f7cdecce1b9283afb86f',
    MenuItemSelectLoaderAndDriver: '7b859aa22ff886cf6d985813adac1ff2',
    MenuItemCheckQty: '48eaa421f0d941617add59b628c5aebf',
    MenuItemStartLoading: '2b08dacc518cee527603fa3f2c069f51',
    MenuItemContinueLoading: '09ef75a78ef39544a4d16b871ca2e359',
    MenuItemDelivery: 'b5c3d9832a6a2330a892054b1f9f7b65',
    MenuItemPrintPickingList: 'fc13a92fc0971aef80fca3d0f126bae0',
    MenuItemPrintKoliLabels: '9812a55481abc38139744106a0554e10',
    MenuItemPrintSupplyOrder: '4b9f7ba39e9b60b38dba266d5217767a',
    MenuItemPrintSuratJalan: '4b44de9aa959e3dcd86dcdfff108b520',
    MenuItemCancelSupplyOrderGrouped: '9bcdb05d81e6ccf64a2c4f628f184299',
    MenuItemAmbilBarang: 'b391082985e993a8c10ac8f86dbfca91',
    BtnBulkUpload: 'cf5817b6cf2ce0697e5b8dac294dabf2',
    BtnCreateNewSupplyOrder: '33346c5adb5e8145078d201a19214397',
    MenuItemEdit: 'da8df8bf805d004872219ed00b8882e1',
    MenuItemConfirm: '193c244bcc4e5b2249af7fea4db25353',
    MenuItemCancel: '51541e9ee902afd5092c7174ce1c6a03',
    MenuItemCopy: 'da8e01c8af5d004872219ed00f3aac22',
    BtnAssignBulkSO: '37edbe38911ead42657a7ecb82f4bba8',
  },
} as const

export const useRBACOutboundSOPage = createUseRBAC(OutboundSORBAC.elementID)
export type UseRBACOutboundSOPageType = ReturnType<typeof useRBACOutboundSOPage>
